export const DISABLED_ANIMATION_SLIDE = "DISABLED_ANIMATION_SLIDE";
export const ACTIVATE_ANIMATION_SLIDE = "ACTIVATE_ANIMATION_SLIDE";
